import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-4xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back to Proposals ")
const _hoisted_5 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10 mx-auto text-primary-500 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-primary-500" }, "Loading proposal...", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "text-center py-12 bg-white rounded-xl border border-red-200"
}
const _hoisted_10 = { class: "text-red-600" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Return to proposals ")
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "bg-white rounded-xl border border-primary-200 p-6 md:p-8 mb-6" }
const _hoisted_14 = { class: "flex flex-wrap items-center gap-3 mb-4" }
const _hoisted_15 = { class: "text-display-sm font-heading text-primary-800 mb-4" }
const _hoisted_16 = { class: "flex items-center gap-4 mb-6 pb-6 border-b border-sand" }
const _hoisted_17 = { class: "flex items-center gap-3" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center"
}
const _hoisted_20 = { class: "text-sm font-medium text-primary-700" }
const _hoisted_21 = { class: "font-medium text-primary-800" }
const _hoisted_22 = { class: "text-sm text-primary-500" }
const _hoisted_23 = { class: "prose prose-gray max-w-none mb-8" }
const _hoisted_24 = { class: "whitespace-pre-wrap text-primary-700 leading-relaxed" }
const _hoisted_25 = {
  key: 0,
  class: "bg-primary-50 rounded-lg p-4 mb-6"
}
const _hoisted_26 = { class: "flex justify-between items-center mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-primary-800" }, "Support Progress", -1)
const _hoisted_28 = { class: "text-sm text-primary-600" }
const _hoisted_29 = { class: "h-3 bg-primary-100 rounded-full overflow-hidden" }
const _hoisted_30 = { class: "mt-2 text-sm text-primary-500" }
const _hoisted_31 = {
  key: 0,
  class: "bg-white rounded-xl border border-primary-200 p-6 mb-6"
}
const _hoisted_32 = { class: "text-lg font-heading font-semibold text-primary-800 mb-4" }
const _hoisted_33 = { class: "flex flex-wrap gap-2" }
const _hoisted_34 = { class: "text-sm text-primary-700" }
const _hoisted_35 = { class: "bg-white rounded-xl border border-primary-200 p-6" }

import { computed, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { useProposalStore } from "@/stores/proposals";
import { useAuthStore } from "@/stores/auth";
import SupportButton from "@/components/proposals/SupportButton.vue";
import ProposalComments from "@/components/proposals/ProposalComments.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const proposalStore = useProposalStore();
const authStore = useAuthStore();

const loading = computed(() => proposalStore.loading);
const error = computed(() => proposalStore.error);
const proposal = computed(() => proposalStore.currentProposal);

const statusLabels: Record<ProposalStatus, string> = {
  draft: "Draft",
  gathering_support: "Gathering Support",
  ready_for_vote: "Ready for Vote",
  voting: "Voting Now",
  approved: "Approved",
  rejected: "Rejected",
};

const statusColors: Record<ProposalStatus, string> = {
  draft: "bg-primary-100 text-primary-800",
  gathering_support: "bg-amber-100 text-amber-800",
  ready_for_vote: "bg-accent-100 text-accent-800",
  voting: "bg-blue-100 text-blue-800",
  approved: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
};

const categoryLabels: Record<ProposalCategory, string> = {
  maintenance: "Maintenance",
  improvement: "Improvement",
  policy: "Policy",
  event: "Event",
  financial: "Financial",
  other: "Other",
};

const categoryColors: Record<ProposalCategory, string> = {
  maintenance: "bg-amber-100 text-amber-800",
  improvement: "bg-accent-100 text-accent-800",
  policy: "bg-blue-100 text-blue-800",
  event: "bg-purple-100 text-purple-800",
  financial: "bg-emerald-100 text-emerald-800",
  other: "bg-primary-100 text-primary-800",
};

const statusLabel = computed(() =>
  proposal.value ? statusLabels[proposal.value.status] : ""
);
const statusClass = computed(() =>
  proposal.value ? statusColors[proposal.value.status] : ""
);
const categoryLabel = computed(() =>
  proposal.value ? categoryLabels[proposal.value.category] : ""
);
const categoryClass = computed(() =>
  proposal.value ? categoryColors[proposal.value.category] : ""
);

const progressPercent = computed(() => {
  if (!proposal.value || proposal.value.support_threshold === 0) return 100;
  return Math.min(
    100,
    (proposal.value.support_count / proposal.value.support_threshold) * 100
  );
});

const hasUserSupported = computed(() => {
  if (!proposal.value || !authStore.user_details.my_house) return false;
  const houseId = authStore.user_details.my_house.id;
  return proposal.value.supporters.some((s) => s.house.id === houseId);
});

const isUserAuthor = computed(() => {
  if (!proposal.value) return false;
  return proposal.value.author.id === authStore.user_id;
});

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const handleSupported = () => {
  // Refresh proposal data after support
  const proposalId = Number(route.params.id);
  proposalStore.fetchProposal(proposalId);
};

const handleWithdrawn = () => {
  // Already refreshed in the store action
};

const handleCommentAdded = () => {
  // Comment already added via store
};

onMounted(async () => {
  const proposalId = Number(route.params.id);
  if (proposalId) {
    try {
      await proposalStore.fetchProposal(proposalId);
    } catch (err) {
      console.error("Failed to fetch proposal", err);
    }
  }
});

onUnmounted(() => {
  proposalStore.clearCurrentProposal();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/proposals",
        class: "inline-flex items-center gap-2 text-primary-700 hover:text-primary-800 mb-6"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(error)), 1),
              _createVNode(_component_router_link, {
                to: "/proposals",
                class: "mt-4 inline-block text-accent-700 hover:text-accent-800"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]))
          : (_unref(proposal))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["px-3 py-1 text-xs font-medium uppercase tracking-wide rounded-full", _unref(statusClass)])
                    }, _toDisplayString(_unref(statusLabel)), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["px-3 py-1 text-xs font-medium uppercase tracking-wide rounded-full", _unref(categoryClass)])
                    }, _toDisplayString(_unref(categoryLabel)), 3)
                  ]),
                  _createElementVNode("h1", _hoisted_15, _toDisplayString(_unref(proposal).title), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_unref(proposal).author.profile)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(proposal).author.profile,
                            class: "w-10 h-10 rounded-full object-cover",
                            alt: ""
                          }, null, 8, _hoisted_18))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(proposal).author.first_name.charAt(0)) + _toDisplayString(_unref(proposal).author.last_name.charAt(0)), 1)
                          ])),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(proposal).author.first_name) + " " + _toDisplayString(_unref(proposal).author.last_name), 1),
                        _createElementVNode("p", _hoisted_22, " Proposed " + _toDisplayString(formatDate(_unref(proposal).created_on)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(proposal).description), 1)
                  ]),
                  (_unref(proposal).status === 'gathering_support')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(proposal).support_count) + " / " + _toDisplayString(_unref(proposal).support_threshold) + " supporters ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", {
                            class: "h-full bg-accent-600 rounded-full transition-all duration-500",
                            style: _normalizeStyle({ width: _unref(progressPercent) + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(proposal).support_threshold - _unref(proposal).support_count > 0
                  ? `${
                      _unref(proposal).support_threshold - _unref(proposal).support_count
                    } more supporters needed`
                  : "Threshold reached!"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(SupportButton, {
                    "proposal-id": _unref(proposal).id,
                    status: _unref(proposal).status,
                    "has-supported": _unref(hasUserSupported),
                    "is-author": _unref(isUserAuthor),
                    onSupported: handleSupported,
                    onWithdrawn: handleWithdrawn
                  }, null, 8, ["proposal-id", "status", "has-supported", "is-author"])
                ]),
                (_unref(proposal).supporters.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("h3", _hoisted_32, " Supporters (" + _toDisplayString(_unref(proposal).supporters.length) + ") ", 1),
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(proposal).supporters, (support) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: support.id,
                            class: "inline-flex items-center gap-2 px-3 py-2 bg-primary-50 rounded-full"
                          }, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(support.house.house_number) + " " + _toDisplayString(support.house.street), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(ProposalComments, {
                    "proposal-id": _unref(proposal).id,
                    comments: _unref(proposal).comments,
                    onCommentAdded: handleCommentAdded
                  }, null, 8, ["proposal-id", "comments"])
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})